import { Ref, MutableRefObject } from "react";

export const applyRef = <T>(ref: Ref<T>, value: T) => {
  if (ref == null) return;

  if (typeof ref === "function") {
    ref(value);
  } else {
    // eslint-disable-next-line no-param-reassign
    (ref as MutableRefObject<T>).current = value;
  }
};
